import transactionActionTypes from './transactions.types';

export const fetchTransactionsStart = (token) => ({
    type: transactionActionTypes.FETCH_TRANSACTIONS_START,
    payload: token
});

export const fetchTransactionsSuccess = (transactions) => ({
    type: transactionActionTypes.FETCH_TRANSACTIONS_SUCCESS,
    payload: transactions
});

export const fetchTransactionsFailure = (error) => ({
    type: transactionActionTypes.FETCH_TRANSACTIONS_FAILURE,
    payload: error
});
